import { useEffect, useRef, useState } from 'react'
import { t } from 'i18next'

import styles from './ContextBlock.module.css'

type ContextStyle = 'contentContext' | 'exerciseContext'

interface ContextBlockProps {
  text?: string
  title?: string
  contextStyle?: ContextStyle
}

const isEllipsisActive = (e: HTMLParagraphElement) => {
  return e.offsetHeight < e.scrollHeight
}

const ContextBlock = ({
  text = '',
  title = 'Insights',
  contextStyle = 'contentContext',
}: ContextBlockProps) => {
  const [showFullText, setShowFullText] = useState(false)
  const [showFullTextToggle, setShowFullTextToggle] = useState(false)
  const elementRef = useRef<HTMLParagraphElement>(null)

  const toggleText = () => {
    if (!showFullTextToggle) {
      return
    }

    setShowFullText((prev) => !prev)
  }

  useEffect(() => {
    if (elementRef.current) {
      setShowFullTextToggle(isEllipsisActive(elementRef.current))
    }
  }, [elementRef, text])

  return (
    <div className={`${styles.baseContextContainer} ${styles[contextStyle]}`}>
      <div>
        <span className={styles.contextMenty}>M</span>
        <span className={styles.contextTitle}>{title}</span>
      </div>
      <div className={styles.context} onClick={toggleText}>
        <p
          ref={elementRef}
          className={showFullText ? styles.expanded : styles.collapsed}
        >
          {text}
        </p>
        {showFullTextToggle && (
          <span>{showFullText ? t('context.less') : t('context.more')}</span>
        )}
      </div>
    </div>
  )
}

export default ContextBlock
